import deepEqual from "deep-equal";
export const isConsistent = (array, comparator = deepEqual) => {
    return array.every((elem) => comparator(elem, array[0]));
};
export const unique = (array, comparator = (a, b) => a === b) => {
    const uniques = [];
    array.forEach((elem) => {
        if (uniques.findIndex((unique) => comparator(elem, unique)) === -1) {
            uniques.push(elem);
        }
    });
    return uniques;
};
export const isNotEmpty = (t) => {
    return t !== undefined && t !== null;
};
